import { Profile } from "../authentication/model/Profile";
import { CallResult, doApiGet, doApiPost } from "./Requests";

export const profileApi = {
  getCurrentProfile: async (): Promise<CallResult<Profile>> => {
    return await doApiGet<Profile>("/api/me");
  },

  changePassword: async (
    userId: string,
    data: { currentPassword: string; newPassword: string }
  ): Promise<CallResult<null>> => {
    return await doApiPost(`/api/users/${userId}/password`, data);
  },
};